import { useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { FaSteam, FaYoutube } from "react-icons/fa6";

function Annexation() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  let steamLink = "https://store.steampowered.com/app/4622430/Annexation/"
  let trailerLink = "https://www.youtube.com/watch?v=6yzR4D9MDRU"
  
  return (
    <Container fluid className="annexation-bgimage">
      <Row className="align-items-center">
        <Col className="mx-auto">
          <div className="annexation-logo"
            style={{ "margin-top": "80px", "margin-left": "380px"  }}
            alt="Annexation Logo"
          >
          </div>
        </Col>
      </Row>
      <Row style={{"padding-top":"100px"}}>
        <Col>
        <Button variant="danger" href={trailerLink} target="_blank">
          <FaYoutube /> Trailer
        </Button>
        <Button
            variant="danger"
            href={steamLink}
            target="_blank"
            style={{ marginLeft: "20px" }}
          >
            <FaSteam /> Steam
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default Annexation;
